const TranslationHeader = () => (
    <nav className="navbar w-100 bg-primary p-4"></nav>
)

export default TranslationHeader
